<app-base-modal
  [title]="technicalConclusionResourceType.name"
  [showStateToggle]="isValid()"
>
  <div class="wrapper">
    <mat-accordion [multi]="true">
      @for (technicalConclusion of technicalConclusionsData(); track $index) {
        <mat-expansion-panel [expanded]="technicalConclusion.id === 0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="title">
                <div class="title-text">
                  {{ technicalConclusion.conclusionNumber }}
                </div>
                @if (!!technicalConclusion.id && isEditModeActive) {
                  <button
                    mat-mini-fab
                    class="btn-delete"
                    (click)="handleDelete($event, technicalConclusion.id, $index)"
                  >
                    <mat-icon class="btn-delete-icon">delete</mat-icon>
                  </button>
                }
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-technical-conclusion-form
            [parentId]="parentId()"
            [technicalConclusionData]="technicalConclusion"
            [technicalConclusionFormGroup]="technicalConclusionFormGroups()[$index]"
            [noFirstData]="noFirstData()"
            [isEditModeActive]="isEditModeActive"
            (updateTechnicalConclusionData)="updateTechnicalConclusionData($event, $index)"
            (deleteTechnicalConclusion)="deleteTechnicalConclusion($index)"
          />
          @if (technicalConclusion.id) {
            <div
              app-technical-conclusion-files
              [technicalConclusionId]="technicalConclusion.id"
              [isEditModeActive]="isEditModeActive"
              class="technical-conclusion-files"
            ></div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      type="button"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
    <button
      mat-button
      color="primary"
      type="button"
      [disabled]="!isValid()"
      (click)="handleAddNew()"
    >
      Добавить новое
    </button>
  </div>
</app-base-modal>
